import {set} from "lodash/object";
import {Kind} from "graphql";

export default function url(field, pathField = 'path', urlGenerator: Function = null) {
    const path = field.split('.');
    if (path.length < 2) {
        path.unshift('Query')
    }
    urlGenerator = urlGenerator || ((parent, pathField, manifest) => {
        return `/storage/${manifest.name}/${parent[pathField]}`
    });
    return ({typeDefs, resolvers}) => {
        const path = field.split('.');
        if (path.length < 2) {
            path.unshift('Query')
        }

        set(resolvers, path.join('.'), function (_, args, ctx, info) {
            return urlGenerator(_, pathField, ctx);
        })

        const directive = {
            kind: Kind.DIRECTIVE,
            name: {kind: Kind.NAME, value: 'requires'},
            arguments: [{
                kind: Kind.ARGUMENT, name: {kind: Kind.NAME, value: 'fields'}, value:
                    {
                        kind: Kind.ARGUMENT,
                        name: {kind: Kind.NAME, value: 'handler'},
                        value: {kind: 'StringValue', value: pathField, block: false}
                    }
            }]
        }
        const typeIndex = typeDefs.definitions.findIndex(d => d.name?.value === path[0]);
        const fieldIndex = typeDefs.definitions[typeIndex].fields.findIndex(f => f.name?.value === path[1]);
        typeDefs.definitions[typeIndex].fields[fieldIndex].directives.push(directive)

        return {typeDefs, resolvers};
    }
}
